import {doc} from './docs.js';
import {BANG} from 'zobject/data-types.js';
import {exportToWAV} from "api/exportToWav.js"
import ipfs from "decentralized/Ipfs.js";

doc(
    "record.mix",
    {
        "start/stop" : "1 for start to for stop"
    },
    "Records the global mix to a file",
    () => 3,
);
export const record_mix = (object) => {
    let channelMixer = object.sequencerEngine.channelMixer;
    return ([msg]) => {
        let {recorderWorklet} = channelMixer;
        if (!recorderWorklet) {
            return;
        }
        // when msg = 0 stop and output buffer
        // when msg = 1 start recording
        if (msg === 0) {
            recorderWorklet.stop();
            object.sendMessage(object.outputByNumber(2), BANG);
            recorderWorklet.getBuffer().then(
                async x => {
                    let wav = await exportToWAV(x);
                    let hash = await ipfs.addArrayBuffer(wav);
                    object.sendMessage(object.outputByNumber(0), hash);
                    object.sendMessage(object.outputByNumber(1), wav);
                });
        } else if (msg === 1) {
            recorderWorklet.record();
        }
    };
};

doc(
    "record.pause",
    {
        "start/stop" : "1 for start to for stop"
    },
    "Records the global mix to a file",
    () => 3,
);
export const record_pause= (object) => {
    let channelMixer = object.sequencerEngine.channelMixer;
    return ([msg]) => {
        let {recorderWorklet} = channelMixer;
        if (!recorderWorklet) {
            return;
        }
        recorderWorklet.stop();
    };
};



// nother node is exportToWAV

// other is addToIPFS
